import { Button, Modal } from 'react-bootstrap'

interface IProps {
    show: boolean,
    fullName: string,
    onYes: () => void
    onNo: () => void
}

const MarkReviewed = (props: IProps) => {
    return (
        <Modal backdrop='static' show={props.show} onHide={props.onNo}>
            <Modal.Header closeButton>
                <Modal.Title>Mark As Reviewed?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                Are you sure you want to mark <strong>{props.fullName}</strong> as reviewed?
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onYes}>Yes, Mark as Reviewed</Button>
                <Button onClick={props.onNo}>No, Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default MarkReviewed;